import getSelected from './getSelected';

// ----------------------------------------------------------------------------

function getValue(element: HTMLSelectElement): string | string[] {
    return getSelected(element);
}

// ----------------------------------------------------------------------------

export default getValue;
